import axios from 'axios';
//import _ from 'lodash';

import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';

import {typesUsercreddet} from '../svtypes/usercreddet'

const _ = require('lodash')
/*
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }

*/






export function authenticateUsercredNow_svnakj16(rqValues){
    console.log('****SV***APR9****SVsv get dispatch form hooks')
   // console.log(dispatch)
    console.log('%%%%%%%%%%%%%%%sv++++REST API For authenticateUsercredNow from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svauthenticateUsercredBegin())
        //authenticateUsercredNowSV
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/authenticateUsercredNowSV`
       // const urlOld = `${SV_SOJ_ORCMOCK_ADDRESS}/account/authenticateUsercredNowAndreguserDetail`
       const headers = {'Content-Type': 'application/json'}

        //this will create only 
        axios.post(url, rqValues, {headers:headers})
        .then(
            r => {
                let comData = {
                    "my_data_usercred_confirmation" : {

                        "status":"OK",
                        "reguserId":"UU12345",
                        "saveDate":"Jan 3027"
                    }
                }
                if(r.data){
                   
                   
                    comData.my_data_profile = r.data
                    comData.my_data_profile.username = comData.my_data_profile.login
                    comData.my_data_profile.id = comData.my_data_profile.customerId

                   
                    dispatch(getAuthenticateUsercredSuccess(comData))
                }
                else {
                    comData.my_data_profile = {}
                    comData.my_data_profile.status = "FAILED"
                    comData.my_data_profile.customerId = -1
                    comData.my_data_profile.login = null

                    dispatch(getAuthenticateUsercredSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getAuthenticateUsercredError(e))
        )
    }

}


export const svlogoutAction = () => dispatch => {
    const my_data_profile={
        "addressId": -11,
        "customerId": -11,
        "username": "",
        "password": "",
        "name": "New user",
        "fname": "",
        "lname": "",
        "phone": "",
        "email": "",
        "login": "SVDefault",
       
        "otherDetails": "",
        "city": "",
        "state": "",
        "country": "",
        "address": null,
        "zipcode": "",
        "isdcode": "",
        "addressType": "8",
        "createdDate": null,
        "modifiedDate": null,
        "createdBy": null,
        "modifiedBy": null
    };
    dispatch({
        type:typesUsercreddet.GET_SAVEUSERCRED_LOGOUT,

        payload:{"my_data_profile": my_data_profile}
        
    })
}

export const svauthenticateUsercredBegin = () => dispatch => {
    dispatch({
        type:typesUsercreddet.GET_SAVEUSERCRED_BEGIN
        
    })
}

export const getLoadProfileallError = (e) =>dispatch => {
    dispatch({
        type:'GET_SVPROFILEALL_ERROR',
        error:e
    })
}


export const getAuthenticateUsercredError = (e) =>dispatch => {
    dispatch({
        type:typesUsercreddet.GET_SAVEUSERCRED_ERROR,
        error:e
    })
}



export const getAuthenticateUsercredSuccess = (data) => dispatch => {
    dispatch({
        type: typesUsercreddet.GET_SAVEUSERCRED_SUCCESS,
        payload: data
    })
}

export function authenticateUsercredNow_svj31bak_working(rqValues){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For authenticateUsercredNow from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svauthenticateUsercredBegin())
        //authenticateUsercredNowSV
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/authenticateUsercredNowSV`
        const urlOld = `${SV_SOJ_ORCMOCK_ADDRESS}/account/authenticateUsercredNowAndreguserDetail`
        /*svj31 start*/
        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoEmptyIdList = {"docId":["USA"],"hsetname":"HotelInvDB"}
        const headers = {'Content-Type': 'application/json'}

        /*svj31 end*/
        //this will create only 
        axios.post(url, rqValues, {headers:headers})
        .then(
            r => {
                let comData = {
                    "my_data_usercred_confirmation" : {

                        "status":"OK",
                        "reguserId":"UU12345",
                        "saveDate":"Jan 3027"
                    }
                }
                if(r.data){
                   
                   if(!r.data.customerId){
                       let emsg = 'Login Failde'
                       dispatch(getAuthenticateUsercredError(emsg))
                   }
                   if(r.data.customerId < 1){
                    let emsg = 'Login Failde'
                    dispatch(getAuthenticateUsercredError(emsg))
                }
                    comData.my_data_profile = r.data
                    comData.my_data_profile.username = comData.my_data_profile.login
                    comData.my_data_profile.id = comData.my_data_profile.customerId

                   
                    dispatch(getAuthenticateUsercredSuccess(comData))
                }
                else {
                    comData.my_data_profile = {}
                    comData.my_data_profile.status = "FAILED"
                    comData.my_data_profile.customerId = -1
                    comData.my_data_profile.login = null

                    dispatch(getAuthenticateUsercredSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getAuthenticateUsercredError(e))
        )
    }

}


//reset
export const clearformUsercred = () => dispatch => {
    let data = {
        "id": -1,
        "username": "",
        "password": ""
    }
    dispatch({
        id:-1,
        type: 'RESETFORM_SAVEUSERCRED_SUCCESS',
        payload: data
    })
}

/*svj31 start*/

export function authenticateUsercredNow(rqValues){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For authenticateUsercredNow from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svauthenticateUsercredBegin())
        //authenticateUsercredNowSV
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/authenticateUsercredNowSV`
        const urlOld = `${SV_SOJ_ORCMOCK_ADDRESS}/account/authenticateUsercredNowAndreguserDetail`
        /*svj31 start*/
        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoEmptyIdList = {"docId":["USA"],"hsetname":"HotelInvDB"}
        const headers = {'Content-Type': 'application/json'}

        /*svj31 end*/
        //this will create only 
        axios.all([
            axios.post(url, rqValues, {headers:headers}),
            axios.post(urlGeoList, bodyGeoEmptyIdList, {headers:headers})
           
        ], {
  timeout: 7000
})
        .then(  
            axios.spread((r,r2)=>{
                let my_data_geo = null
                //svj31 rstart
                let comData = {
                    "my_data_usercred_confirmation" : {

                        "status":"OK",
                        "reguserId":"UU12345",
                        "saveDate":"Jan 3027"
                    }
                }
                console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********1a')
                
                if( r2.data ){
                    //svaiiisd_geoPost start
                    
                    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********2a')
                    console.log(r.data )
                    if(  r.data.countryTypes && r.data.countryTypes.length>0){
                     my_data_geo = r.data
                     comData.my_data_geo = my_data_geo
                    }
                    console.log(comData )
                    //svaiiisd_geoPost end

                 
                }else{
                    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********2b')
                    comData.my_data_geo = null
                  
                }

                  
                if(r.data){
                   
                   if(!r.data.customerId){
                       let emsg = 'Login Failde'
                       dispatch(getAuthenticateUsercredError(emsg))
                   }
                   if(r.data.customerId < 1){
                    let emsg = 'Login Failde'
                    dispatch(getAuthenticateUsercredError(emsg))
                }
                    comData.my_data_profile = r.data
                    comData.my_data_profile.username = comData.my_data_profile.login
                    comData.my_data_profile.id = comData.my_data_profile.customerId

                   
                    dispatch(getAuthenticateUsercredSuccess(comData))
                }
                else {
                    comData.my_data_profile = {}
                    comData.my_data_profile.status = "FAILED"
                    comData.my_data_profile.customerId = -1
                    comData.my_data_profile.login = null

                    dispatch(getAuthenticateUsercredSuccess(comData))
                }
                //svj31 reend
                //svsj31 start
 


               

                //spread svj31 end

            })

         ).catch(
            e=>dispatch(getAuthenticateUsercredError(e))
        )
    }

}

export const authenticateUsercredNowSVhook=(dispatch,rqValues)=>{
    console.log('%%%%%%%%%%%%%%%sv++++REST API For authenticateUsercredNowSVhook  dispatch, rqValues')
    console.log(dispatch)
    console.log(rqValues)
    console.log('%%%%%%%%%%%%%%%sv++++REST API For authenticateUsercredNowSVhook from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svauthenticateUsercredBegin())
        //authenticateUsercredNowSV
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/authenticateUsercredNowSV`
        const urlOld = `${SV_SOJ_ORCMOCK_ADDRESS}/account/authenticateUsercredNowAndreguserDetail`
        /*svj31 start*/
        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoEmptyIdList = {"docId":["USA"],"hsetname":"HotelInvDB"}
        const headers = {'Content-Type': 'application/json'}

        /*svj31 end*/
        //this will create only 
        axios.all([
            axios.post(url, rqValues, {headers:headers}),
            axios.post(urlGeoList, bodyGeoEmptyIdList, {headers:headers})
           
        ], {
  timeout: 7000
})
        .then(  
            axios.spread((r,r2)=>{
                let my_data_geo = null
                //svj31 rstart
                let comData = {
                    "my_data_usercred_confirmation" : {

                        "status":"OK",
                        "reguserId":"UU12345",
                        "saveDate":"Jan 3027"
                    }
                }
                console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********1a')
                
                if( r2.data ){
                    //svaiiisd_geoPost start
                    
                    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********2a')
                    console.log(r.data )
                    if(  r.data.countryTypes && r.data.countryTypes.length>0){
                     my_data_geo = r.data
                     comData.my_data_geo = my_data_geo
                    }
                    console.log(comData )
                    //svaiiisd_geoPost end

                 
                }else{
                    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********2b')
                    comData.my_data_geo = null
                  
                }

                  
                if(r.data){
                   
                   if(!r.data.customerId){
                       let emsg = 'Login Failde'
                       dispatch(getAuthenticateUsercredError(emsg))
                   }
                   if(r.data.customerId < 1){
                    let emsg = 'Login Failde'
                    dispatch(getAuthenticateUsercredError(emsg))
                }
                    comData.my_data_profile = r.data
                    comData.my_data_profile.username = comData.my_data_profile.login
                    comData.my_data_profile.id = comData.my_data_profile.customerId

                   
                    dispatch(getAuthenticateUsercredSuccess(comData))
                }
                else {
                    comData.my_data_profile = {}
                    comData.my_data_profile.status = "FAILED"
                    comData.my_data_profile.customerId = -1
                    comData.my_data_profile.login = null

                    dispatch(getAuthenticateUsercredSuccess(comData))
                }
                //svj31 reend
                //svsj31 start
 


               

                //spread svj31 end

            })

         ).catch(
            e=>dispatch(getAuthenticateUsercredError(e))
        )
    }

}
/*svj31 end*/

/*svapr9 start*/

export function loadUserProfileByCustIdNow(rqValues){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For authenticateUsercredNow from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svauthenticateUsercredBegin())
        //authenticateUsercredNowSV
        //loadProfiledNowSV
       // const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/authenticateUsercredNowSV`
       const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/loadProfiledNowSV`
        const urlOld = `${SV_SOJ_ORCMOCK_ADDRESS}/account/authenticateUsercredNowAndreguserDetail`
        /*svj31 start*/
        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoEmptyIdList = {"docId":["USA"],"hsetname":"HotelInvDB"}
        const headers = {'Content-Type': 'application/json'}

        /*svj31 end*/
        //this will create only 
        axios.all([
            axios.post(url, rqValues, {headers:headers}),
            axios.post(urlGeoList, bodyGeoEmptyIdList, {headers:headers})
           
        ], {
  timeout: 1000
})
        .then(  
            axios.spread((r,r2)=>{
                let my_data_geo = null
                //svj31 rstart
                let comData = {
                    "my_data_usercred_confirmation" : {

                        "status":"OK",
                        "reguserId":"UU12345",
                        "saveDate":"Jan 3027"
                    }
                }
                console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********1a')
                
                if( r2.data ){
                    //svaiiisd_geoPost start
                    
                    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********2a')
                    console.log(r.data )
                    if(  r.data.countryTypes && r.data.countryTypes.length>0){
                     my_data_geo = r.data
                     comData.my_data_geo = my_data_geo
                    }
                    console.log(comData )
                    //svaiiisd_geoPost end

                 
                }else{
                    console.log('svj25 ACTIONSVSVSVSVSV((((((((((((((my_data_geo*********2b')
                    comData.my_data_geo = null
                  
                }
                const ob = r.data

                   
                if(ob.status && ob.status !=200){
                    let eeb = {

                    }
                    eeb.errob = ob
                    dispatch(getLoadProfileallError(eeb))
                }else{
                  
                    if(r.data){
                    
                    if(!r.data.customerId){
                        let emsg = 'Login Failde'
                        dispatch(getAuthenticateUsercredError(emsg))
                    }
                    if(r.data.customerId < 1){
                        let emsg = 'Login Failde'
                        dispatch(getAuthenticateUsercredError(emsg))
                    }
                        comData.my_data_profile = r.data
                        comData.my_data_profile.username = comData.my_data_profile.login
                        comData.my_data_profile.id = comData.my_data_profile.customerId

                    
                        dispatch(getAuthenticateUsercredSuccess(comData))
                    }else {
                        comData.my_data_profile = {}
                        comData.my_data_profile.status = "FAILED"
                        comData.my_data_profile.customerId = -1
                        comData.my_data_profile.login = null

                        dispatch(getAuthenticateUsercredSuccess(comData))
                    }
                }
                //svj31 reend
                //svsj31 start
 


               

                //spread svj31 end

            })

         ).catch(
            e=>dispatch(getAuthenticateUsercredError(e))
        )
    }

}

/*svapr9 end*/